export default __webpack_public_path__ + "static/media/Picpay.7000904a.svg";